import { render } from "./CoachForm.vue?vue&type=template&id=aa7071f0&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=aa7071f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aa7071f0"

export default script